export * from './article-faq/ArticleFAQ';
